import { create } from "zustand";

/**
 * "A generated system just landed on this canvas." Deliberately **not
 * persisted** — it marks a moment, not a property of the project.
 */
type PostGenerationState = {
  justPlaced: boolean;
  markPlaced: () => void;
  dismiss: () => void;
};

export const useAiPostGeneration = create<PostGenerationState>((set) => ({
  justPlaced: false,
  markPlaced: () => set({ justPlaced: true }),
  dismiss: () => set({ justPlaced: false }),
}));
